import React from 'react';
import { isNil } from 'lodash';
import Anchor from '../../../../components/link/Anchor';
import {
  ORDER_DELIVERY_TYPE,
  ENABLE_DELIVERY_TRACKING_ORDER_ITEM_STATUS_LIST,
} from '../../../../constants/service/app/orderConstants';

const OpenOrderDeliveryTracking = (props) => {
  const { text = '추적하기', deliveryId, getOrderDeliveryTrackingData, targetStatus, deliveryType } = props;

  /**
   * 링크로 연결할 데이터가 없다면
   * '-' 를 반환함
   */
  if (isNil(text) || isNil(deliveryId) || !getOrderDeliveryTrackingData) {
    return '-';
  }

  /**
   * 상품 주문 상태가 배송 중(6)ㅡ 배송완료(7), 교환품 배송 중(6), 교환품 배송완료(7) 이고
   * 배송방법이 택배, 등기, 소포가 아닌 경우에는
   * '-' 를 반환함
   */
  if (
    !isNil(targetStatus) &&
    (!ENABLE_DELIVERY_TRACKING_ORDER_ITEM_STATUS_LIST.includes(targetStatus) ||
      deliveryType !== ORDER_DELIVERY_TYPE.PARCEL_DELIVERY)
  ) {
    return '-';
  }

  return (
    <Anchor
      color="primary"
      isUnderLine
      text={text}
      onClick={() =>
        getOrderDeliveryTrackingData({
          deliveryId,
        })
      }
    />
  );
};

export default OpenOrderDeliveryTracking;
